<ng-container
    *ngIf="
        mapAirspaceCheckerService.currentParameters$
            | async as currentParameters
    "
>
    <ng-container
        *ngIf="
            mapAirspaceCheckerService.parameterValidity$
                | async as parameterValidity
        "
    >
        <ng-container
            *ngIf="
                !showSimplifiedOutcome ||
                airspaceStatus === 'CHECKING' ||
                airspaceStatus === 'IDLE'
            "
        >
            <div
                *ngIf="isDrawing"
                class="airspace-check-button incomplete"
                (click)="stopDrawing()"
            >
                <span class="fa fa-radar"></span>
                &nbsp;&nbsp;{{
                    allowDrawing && !canCheckAirspace
                        ? 'Cancel Drawing'
                        : 'Cancel Airspace Check'
                }}
            </div>
            <div
                *ngIf="!isDrawing"
                class="airspace-check-button"
                [ngClass]="{
                    idle:
                        airspaceStatus === 'IDLE' ||
                        (allowDrawing && !canCheckAirspace),
                    incomplete:
                        canCheckAirspace &&
                        (airspaceStatus === 'INCOMPLETE' ||
                            airspaceStatus === 'CHECKING'),
                    'can-fly': airspaceStatus === 'CAN_FLY',
                    'can-fly-conditions':
                        airspaceStatus === 'CAN_FLY_CONDITIONS',
                    'cannot-fly': airspaceStatus === 'CANNOT_FLY'
                }"
                (click)="airspaceCheckClick()"
            >
                <ng-container
                    *ngIf="!(allowDrawing && !canCheckAirspace)"
                    [ngSwitch]="airspaceStatus"
                >
                    <ng-container *ngSwitchCase="'IDLE'">
                        <span class="fa fa-radar"></span>
                        <ng-container
                            *ngIf="
                                allowDrawing && firstCheck;
                                else standardIdleText
                            "
                        >
                            &nbsp;&nbsp;Start Airspace Check
                        </ng-container>
                        <ng-template #standardIdleText
                            >&nbsp;&nbsp;Airspace Check</ng-template
                        >
                    </ng-container>
                    <ng-container *ngSwitchCase="'INCOMPLETE'">
                        {{
                            canCheckAirspace
                                ? 'Airspace Check Incomplete'
                                : 'No Airspace Check Available'
                        }}
                    </ng-container>
                    <ng-container *ngSwitchCase="'CHECKING'">
                        <span class="fa fa-spinner fa-pulse fa-fw"></span>
                        &nbsp;&nbsp;Checking
                    </ng-container>
                    <ng-container *ngSwitchCase="'CAN_FLY'">
                        <span class="fad fa-check-circle"></span>
                        &nbsp;&nbsp;Airspace is good to fly
                    </ng-container>
                    <ng-container *ngSwitchCase="'CAN_FLY_CONDITIONS'">
                        <span class="fad fa-exclamation-circle"></span>
                        &nbsp;&nbsp;Airspace Warning
                    </ng-container>
                    <ng-container *ngSwitchCase="'CANNOT_FLY'">
                        <span class="fad fa-times-circle"></span>
                        &nbsp;&nbsp;Airspace has issues
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="allowDrawing && !canCheckAirspace">
                    <ng-container [ngSwitch]="airspaceStatus">
                        <ng-container *ngSwitchCase="'CHECKING'">
                            <span class="fa fa-spinner fa-pulse fa-fw"></span>
                            &nbsp;&nbsp;Checking
                        </ng-container>
                        <ng-container *ngSwitchDefault>
                            <span class="fa fa-compass-drafting"></span
                            >&nbsp;&nbsp;Draw A Flight Area
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
        </ng-container>
        <div
            *ngIf="
                showSimplifiedOutcome &&
                airspaceStatus !== 'CHECKING' &&
                airspaceStatus !== 'IDLE'
            "
            class="caa-button"
            [ngClass]="{
                'authorisation-unavailable':
                    airspaceStatus === 'INCOMPLETE' ||
                    caaAuthorisationStatus === 'UNKNOWN',
                'authorisation-available':
                    caaAuthorisationStatus === 'AUTHORISATION_REQUIRED',
                'authorisation-incomplete':
                    caaAuthorisationStatus === 'AUTHORISATION_NOT_REQUIRED'
            }"
        >
            <span class="fa fa-radar"></span>
            &nbsp;&nbsp;Airspace Check
        </div>
        <p
            *ngIf="
                (allowDrawing && isDrawing) || (!allowDrawing && !hasFlightArea)
            "
        >
            <em>{{ emptyStateMessage }}</em>
        </p>
        <div
            *ngIf="
                allowDrawing &&
                !isDrawing &&
                !firstCheck &&
                airspaceStatus !== 'CHECKING'
            "
            class="horizontal-container space-between center-children"
        >
            <div class="horizontal-container center-children">
                <span
                    type="button"
                    class="btn btn-link btn-xs"
                    (click)="startDrawing()"
                >
                    Start another check
                </span>

                <button
                    *ngIf="hasResult"
                    type="button"
                    class="btn btn-tertiary"
                    tooltip="Clear airspace check"
                    placement="top"
                    [disabled]="working"
                    (click)="clearCheck()"
                >
                    <span class="fal fa-times-circle"></span>
                </button>
            </div>
            <jurisdiction-links
                *ngIf="!firstCheck && showJurisdictionLinks"
            ></jurisdiction-links>
        </div>
        <ng-container *ngIf="!(allowDrawing && isDrawing)">
            <div
                class="airspace-check-result-container"
                [ngClass]="{
                    dashboard: dashboardCheckerMode !== 'NONE',
                    map: dashboardCheckerMode === 'MAP',
                    both: dashboardCheckerMode === 'BOTH',
                    'has-authorisation': authorisationAvailable
                }"
            >
                <div
                    *ngIf="airspaceInitialised$ | async"
                    [@collapse]="editingAirspaceParameters || !showCheckResult"
                    class="top-buffer bottom-buffer"
                    style="padding: 0 15px"
                >
                    <span
                        class="btn btn-xs"
                        [ngClass]="{
                            'btn-expired': !parameterValidity.airspaceDate,
                            'btn-link': !disableParameters
                        }"
                        (click)="showParameterEditor()"
                        [tooltip]="
                            !parameterValidity.airspaceDate
                                ? 'The date used for this airspace check is in the past. The check results may be inaccurate or incorrect.'
                                : ''
                        "
                        placement="top"
                    >
                        {{
                            currentParameters?.airspaceDate
                                | formatDateTime
                                    : currentParameters?.airspaceTimeZone
                        }}
                        {{ checkerTimeZoneAbbreviation }}
                    </span>
                    <span
                        class="btn btn-xs"
                        (click)="showParameterEditor()"
                        [ngClass]="{ 'btn-link': !disableParameters }"
                    >
                        {{ currentParameters?.airspaceDuration / 3600 }}
                        {{
                            currentParameters?.airspaceDuration / 3600 === 1
                                ? 'hour'
                                : 'hours'
                        }}
                    </span>
                    <span
                        class="btn btn-xs"
                        (click)="showParameterEditor()"
                        [ngClass]="{ 'btn-link': !disableParameters }"
                    >
                        {{
                            currentParameters?.airspaceRuleset?.abbreviation ||
                                currentParameters?.airspaceRuleset?.name ||
                                '-'
                        }}
                    </span>
                    <span
                        class="btn btn-xs"
                        (click)="showParameterEditor()"
                        [ngClass]="{ 'btn-link': !disableParameters }"
                    >
                        {{ currentParameters?.airspaceHeight }}&nbsp;ft AGL
                    </span>
                    <span
                        *ngIf="radius"
                        class="btn btn-xs"
                        (click)="showParameterEditor()"
                        [ngClass]="{ 'btn-link': !disableParameters }"
                    >
                        {{ currentParameters?.radius }}&nbsp;m
                    </span>
                </div>
                <div
                    [@collapse]="!editingAirspaceParameters || !showCheckResult"
                    class="container-scroll modal-scrollbar top-buffer"
                >
                    <map-airspace-parameters
                        (doneEditing)="hideParameterEditor()"
                    ></map-airspace-parameters>
                </div>
                <div
                    *ngIf="!useSimplified"
                    [@collapse]="editingAirspaceParameters || !showCheckResult"
                    class="vertical-container"
                >
                    <airspace-check
                        #airspaceCheck
                        screenIdentifier="location-edit"
                        [hideHeader]="true"
                        linkPosition="NONE"
                    ></airspace-check>
                </div>
                <div
                    *ngIf="
                        useSimplified &&
                        showSimplifiedOutcome &&
                        airspaceStatus !== 'IDLE' &&
                        airspaceStatus !== 'CHECKING'
                    "
                    class="authorisation-details authorisation-incomplete"
                    [ngClass]="{
                        'authorisation-unavailable':
                            airspaceStatus === 'INCOMPLETE' ||
                            caaAuthorisationStatus === 'UNKNOWN',
                        'authorisation-available':
                            caaAuthorisationStatus === 'AUTHORISATION_REQUIRED',
                        'authorisation-incomplete':
                            caaAuthorisationStatus ===
                            'AUTHORISATION_NOT_REQUIRED'
                    }"
                    style="cursor: unset"
                    [ngSwitch]="caaAuthorisationStatus"
                >
                    <ng-container *ngSwitchCase="'AUTHORISATION_REQUIRED'">
                        Authorisation is required for this mission
                    </ng-container>
                    <ng-container *ngSwitchCase="'AUTHORISATION_NOT_REQUIRED'">
                        Authorisation not required but available and recommended
                        for this location
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <ng-container *ngIf="airspaceStatus === 'INCOMPLETE'">
                            Location data incomplete
                        </ng-container>
                        <ng-container *ngIf="airspaceStatus !== 'INCOMPLETE'">
                            Authorisation availability and requirements can not
                            be determined for this location at this time
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div [@collapse]="editingAirspaceParameters || showCheckResult">
                <div
                    class="contents horizontal-container space-between top-buffer"
                >
                    <label
                        tooltip="The date and time of the current airspace result and map data"
                        placement="left"
                        >{{
                            currentParameters.airspaceDate
                                | formatDateTime
                                    : currentParameters.airspaceTimeZone
                        }}</label
                    >
                    <jurisdiction-links
                        *ngIf="firstCheck && showJurisdictionLinks"
                    ></jurisdiction-links>
                </div>
            </div>
        </ng-container>
        <button
            *ngIf="
                jurisdiction?.airspaceCheckSupport === 'AIRSPACE_CHECK' &&
                airspaceStatus !== 'IDLE' &&
                airspaceStatus !== 'INCOMPLETE'
            "
            type="button"
            class="btn btn-sm btn-block btn-link"
            [disabled]="airspaceStatus === 'CHECKING'"
            (click)="showAirspaceCheckDetails()"
        >
            View Result Details
        </button>
        <div *ngIf="authorisationAvailable != null && !isDrawing">
            <div
                style="
                    line-height: 20px;
                    border-radius: 10px;
                    padding: 5px 10px;
                    background: #eee;
                    color: #000;
                    margin-bottom: 5px;
                "
            >
                <span class="fa-regular fa-circle-exclamation"></span>
                {{ authorisationAvailable }}
            </div>
        </div>
        <!-- Don't deactivate button on the form's date being valid, rather use the more forgiving "isInPast" -->
        <button
            *ngIf="
                allowMissionCreation &&
                !editingAirspaceParameters &&
                allowDrawing &&
                canCheckAirspace
            "
            type="button"
            class="btn btn-primary btn-sm btn-block"
            [disabled]="
                working ||
                isDrawing ||
                airspaceStatus == null ||
                airspaceStatus === 'INCOMPLETE' ||
                airspaceStatus === 'CHECKING' ||
                airspaceStatus === 'IDLE' ||
                !parameterValidity.airspaceDuration ||
                !parameterValidity.airspaceRuleset ||
                !parameterValidity.airspaceHeight ||
                !parameterValidity.airspaceTimeZone
            "
            analyticsOn
            analyticsAction="airspace-check-create-mission"
            (click)="requestCreateMission()"
        >
            <span
                [tooltip]="
                    airspaceStatus === 'IDLE'
                        ? 'The airspace checker needs to run for a potential location first. Click on \'Start Airspace Check\' to begin'
                        : !parameterValidity.airspaceDuration
                        ? 'The check duration has to be more than 0 and less than 24 hours'
                        : !parameterValidity.airspaceDate
                        ? 'The selected date and time is in the past'
                        : ''
                "
                placement="left"
            >
                <span class="fa fa-plus"></span> Create Mission
            </span>
        </button>

        <button
            *ngIf="
                allowMissionCreation &&
                !editingAirspaceParameters &&
                allowDrawing &&
                !canCheckAirspace
            "
            type="button"
            class="btn btn-primary btn-sm btn-block"
            [disabled]="
                working ||
                flightArea == null ||
                isDrawing ||
                airspaceStatus === 'CHECKING'
            "
            analyticsOn
            analyticsAction="airspace-check-create-mission"
            (click)="requestCreateMission()"
        >
            <span
                [tooltip]="
                    flightArea == null
                        ? 'Draw a flight area to create a mission'
                        : 'Create a mission from this flight area'
                "
                placement="left"
            >
                <span class="fa fa-plus"></span> Create Mission
            </span>
        </button>
    </ng-container>
</ng-container>
